module.exports = __webpack_public_path__ + "img/dsci0058.52d6159f.jpg";